<template>
    <!-- 5.FAQ -->
    <section class="mx-auto max-w-7xl px-6 lg:px-8 pt-8 sm:pt-20">
        <div class="text-center">
            <h2 class="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl text-center">
                {{ t('faq.title') }}
            </h2>
            <p class="mt-6 text-lg leading-8 text-white/50">{{ t('faq.subtitle') }}</p>
        </div>
        <div class="w-full pt-12">
            <div class="accordion-group">
                <div v-for="(item, index) in faqs" :key="index"
                    class="accordion p-4 sm:p-8 mb-7 transition-all duration-500 bg-zinc-900 rounded-2xl hover:bg-zinc-800 cursor-pointer"
                    @click="toggleAccordion(index)">
                    <div class="accordion-toggle group inline-flex items-center justify-between text-md sm:text-xl leading-8 text-white/50 w-full transition duration-500 text-left"
                        :class="{ active: index === activeIndex }">
                        <h3>{{ item.question }}</h3>
                        <svg class="text-neutral-500 transition duration-500 group-hover:text-orange-400 transform"
                            :class="{ 'rotate-180': index === activeIndex }" width="22" height="22" viewBox="0 0 22 22"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M16.5 8.25L12.4142 12.3358C11.7475 13.0025 11.4142 13.3358 11 13.3358C10.5858 13.3358 10.2525 13.0025 9.58579 12.3358L5.5 8.25"
                                stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="accordion-content w-full overflow-hidden transition-[height] duration-300"
                        :style="{ height: index === activeIndex ? contentHeight : '0px' }" ref="accordionContent">
                        <p class="text-base text-white/30 leading-6 pt-3" v-html="item.answer"></p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';

const { t } = useI18n();
const localePath = useLocalePath();

// 获取当前域名
const { origin } = useRequestURL();
const baseUrl = computed(() => origin);

// 直接使用索引访问翻译
const faqs = computed(() => [
    {
        question: t('faq.items[0].question'),
        answer: t('faq.items[0].answer'),
    },
    {
        question: t('faq.items[1].question'),
        answer: t('faq.items[1].answer'),
    },
    {
        question: t('faq.items[2].question'),
        answer: t('faq.items[2].answer'),
    },
    {
        question: t('faq.items[3].question'),
        answer: t('faq.items[3].answer'),
    },
    {
        question: t('faq.items[4].question'),
        answer: t('faq.items[4].answer'),
    },
    {
        question: t('faq.items[5].question'),
        answer: t('faq.items[5].answer').replace('Contact page', `<a href="${baseUrl.value}${localePath('/contact')}" class="hover:text-orange-400 underline" onclick="event.stopPropagation()">Contact</a> page`),
    },
]);

const activeIndex = ref<number | null>(null);

const toggleAccordion = (index: number) => {
    activeIndex.value = activeIndex.value === index ? null : index;
};

const contentHeight = 'auto';
</script>

<style scoped>
.accordion-toggle.active h3 {
    color: #fff;
}

.accordion-toggle.active svg {
    color: #f97316;
}
</style>